import { useEffect } from 'react';
import dayjs from 'dayjs';
import amplitude from 'service/amplitude';
import { STATE_GROUPS } from 'config';

const useChargingAnalytics = ({ data, serialNumber, watt, idleFee, accTime, amount }) => {
  useEffect(() => {
    const commonParams = {
      serialNumber,
      accTime,
      startTime: dayjs(data.enabledChargingAt).format('YYYY-MM-DD HH:mm'),
      currentTime: dayjs().format('YYYY-MM-DD HH:mm'),
      watt,
      state: data?.state,
      amount,
    };

    if (STATE_GROUPS.CHARGING.includes(data.state)) {
      amplitude.chargingPageView({ ...commonParams });
    } else if (STATE_GROUPS.STOPPED.includes(data.state)) {
      amplitude.chargingStoppedPageView({
        ...commonParams,
        stopReason: data?.stopReason,
      });
    } else if (STATE_GROUPS.ENDED.includes(data.state)) {
      amplitude.serviceEndedPageView({
        ...commonParams,
        refundAmount: data.authAmount - amount,
        idleFee: isNaN(idleFee) ? '-' : idleFee,
        chargingFee: isNaN(idleFee) ? '-' : amount - idleFee,
        stopReason: data?.stopReason,
      });
    }
  }, [data.state, data.stopReason]); // eslint-disable-line
};

export default useChargingAnalytics;
